export const initiativeTimelineSchema = {
  type: 'initiative-timeline',
  label: 'Initiative Timeline',
  description: 'Chronological timeline of initiatives (custom block)',
  icon: 'History',
  isCustom: true,
  defaultContent: {
    heading: 'Initiatives',
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Section Heading', type: 'text' },
  ],
};
